@if (mod) {
<div class="quiz-screen">
  <div class="quiz-screen__header">
    <button class="module-content__back" (click)="goBack()" style="display:inline-flex; margin-bottom: var(--space-md);">
      <span [innerHTML]="Icons.arrow_left | safeHtml"></span> {{ 'Training_Learner.Back_To_Module' | translate }}
    </button>
    <h2>{{ ('Training_Learner.Module_Quiz_Title' | translate).replace('%s', moduleIndex + 1) }}</h2>
    <p style="color: var(--gray-500);">{{ mod.title }}</p>
    <p class="quiz-screen__progress">
      {{ ('Training_Learner.Quiz_Progress' | translate)
        .replace('%q', mod.quiz.length)
        .replace('%p', passThreshold * 100 | number:'1.0-0')
        .replace('%c', (mod.quiz.length * passThreshold | number:'1.0-0'))
        .replace('%t', mod.quiz.length) }}
    </p>
  </div>

  <form (submit)="$event.preventDefault(); submitQuiz()">
    @for (q of mod.quiz; track q.id; let i = $index) {
      <div class="quiz-question card" [id]="'question-' + q.id">
        <p class="quiz-question__number">{{ ('Training.Learner.Question_Number' | translate).replace('%s', i + 1) }}</p>
        <div class="quiz-question__scenario">{{ q.scenario }}</div>
        <p class="quiz-question__text">{{ q.question }}</p>
        <fieldset class="quiz-options" style="border: none;">
          @for (opt of q.options; track opt; let j = $index) {
            <label class="quiz-option"
                   [class.quiz-option--selected]="isSelected(q.id, j)"
                   (click)="selectAnswer(q.id, j)">
              <input type="radio" [name]="q.id" [value]="j" [attr.aria-label]="opt">
              <span class="quiz-option__label">{{ opt }}</span>
            </label>
          }
        </fieldset>
      </div>
    }

    <div class="quiz-submit">
      <p class="quiz-validation-error" [class.quiz-validation-error--visible]="showError">
        {{ 'Training_Learner.Answer_All_Questions' | translate }}
      </p>
      <button type="submit" class="btn btn--primary btn--large">{{ 'Training_Learner.Submit_Answers' | translate }}</button>
    </div>
  </form>
</div>
}
